import { RecomputeIncidentsScreen } from "@src/features/patriot-tools";

export default RecomputeIncidentsScreen;
